<h2 class="sr-only">{{ (isAvPlusActive ? "gebaeude.EgidKantGid" : "EGID") | translate }}</h2>
<form (ngSubmit)="onSubmit()" #form="ngForm">
  <cap-form-row>
    <cap-form-control column-classes="col-md-2,col-md-4" labelKey="gebaeude.Egid">
      <input
        (input)="onUpdateInputValues()"
        (ngModelChange)="gebaeudeStrasse && (gebaeudeStrasse.gwrEgid = $event)"
        [attr.disabled]="isKantgidInput ? '' : null"
        [ngModel]="gebaeudeStrasse && gebaeudeStrasse.gwrEgid"
        #gebaeudeEgid
        appAutofocus
        name="gebaeudeStrasse.egid"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  @if (isAvPlusActive) {
    <cap-form-row>
      <cap-form-control column-classes="col-md-2,col-md-4" labelKey="gebaeude.KantonalerGid">
        <input
          (input)="onUpdateInputValues()"
          (ngModelChange)="gebaeudeStrasse && (gebaeudeStrasse.kantonalerGid = $event)"
          [attr.disabled]="isGwrInput ? '' : null"
          [ngModel]="gebaeudeStrasse && gebaeudeStrasse.kantonalerGid"
          name="kantonalerGid"
          type="text" />
      </cap-form-control>
    </cap-form-row>
  }
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset(gebaeudeEgid)" class="btn btn-outline-primary btn-actionpane" type="button">
        {{ "Zurücksetzen" | translate }}
      </button>
      <button [disabled]="!form.form.valid || (!isKantgidInput && !isGwrInput)" class="btn btn-primary btn-actionpane" type="submit">
        {{ "Suche" | translate }}
      </button>
    </div>
  </div>
</form>
